import { ShowDialog, ShowDialogAsync, ShowWarningDialog } from "../../../react/components/Dialogs/BaseDialog";
import { _ } from "../../../vendor";
import { GlobalStateController } from "bai-react-global-state";
import { CategoryController } from "../../../../common/SlideCategories/CategoryController";
import { findElementsWithImages } from "../../../../common/utils/findElementsWithImages";
import AiGenerationService from "../../../core/services/aiGeneration";
import { computeChangeSet, mergeChanges } from "../../../../common/utils/changeset";
import { RegenerateImageDialog } from "../GenerateImage/RegenerateImageDialog";
import { resetSlideImage, applySlideImage } from "../../../core/models/slide";

const initialState = {
    currentSlide: null,
    generatedIdeas: [],
    isGenerating: false,
    slideCategories: [],
    slideImage: null
};

class SlideAiController extends GlobalStateController {
    get currentSlide() {
        return this._state.currentSlide;
    }

    async setCurrentSlide(slide, canvasController) {
        let metadata = slide.getMetadata();

        await this._updateState({
            currentSlide: slide,
            canvasController,
            generatedIdeas: metadata.generatedIdeas || [],
            slideImage: metadata.generatedModel?.slideImage || null,
            slideCategories: []
        });

        this.buildSlideModels();
    }

    async regenerateIdeas(prompt, { slideType, preserveExactText = false, usePresentationAsContext = true, files = [] } = {}) {
        const { currentSlide } = this._state;

        this._updateState({ isGenerating: true });

        //this.promptRef.current.getMarkdown()
        const genProps = {
            slidePrompt: prompt,
            slideType,
            preserveExactText,
            usePresentationAsContext,
            files,
        };

        // currentSlide.update({ metadata: { ...currentSlide.getMetadata(), ...genProps } });
        console.log("Regenerating slide with state:", genProps);

        let response = await AiGenerationService.generateSlideData({
            slideId: currentSlide.id,
            presentationId: currentSlide.presentation.id,
            slideIndex: currentSlide.getIndex(),
            presentationTopic: currentSlide.presentation.get("metadata").topic,
            ...genProps
        });

        console.log(response);

        if (!response.slides || response.slides.length == 0) {
            ShowWarningDialog({ title: "Slide AI", message: "Sorry, we couldn't generate a new slide for you. Please try again." });
            this.setState({ isGenerating: false });
            return;
        }

        const generatedIdeas = response.slides.map(slide => slide.slideData);

        currentSlide.update({
            metadata: {
                ...currentSlide.getMetadata(),
                ...genProps,
                generatedIdeas,
                hasBeenViewed: true
            }
        });

        await this._updateState({ generatedIdeas, isGenerating: false });
        this.buildSlideModels();
    }

    async buildSlideModels() {
        const { currentSlide, generatedIdeas, slideImage } = this._state;

        let slideCategories = [];
        for (let idea of generatedIdeas) {
            let slideModel = idea.slideModel;

            // copy the slide image from the current slide metadata
            // slideModel.slideImage = currentSlide.getMetadata().generatedModel?.slideImage;
            slideModel.slideImage = slideImage;
            // slideModel.imageStylePrompt = currentSlide.getMetadata().imageStylePrompt;

            console.log("Category", idea.slideCategory);
            console.log("Reasoning:", idea.slideReasoning);
            console.log(slideModel);

            // build slide models for this category
            let category = CategoryController.getCategory(idea.slideCategory);
            let models = category.getSlideModels(slideModel);

            // copy over metadata from the current slide
            models = models.map(model => ({
                ...model,
                metadata: {
                    ...currentSlide.getMetadata(),
                    ...model.metadata,
                    generatedIdeas,
                    aiGenerated: true,
                    // slidePrompt: slidePrompt,
                    slideCategory: idea.slideCategory,
                    slideReasoning: idea.slideReasoning,
                    slideConfidence: idea.slideConfidence
                }
            }));

            models.forEach(model => {
                let elementsWithImages = findElementsWithImages(model);
                for (let element of elementsWithImages) {
                    if (!element.content_value && element.__generateImage) {
                        element.__generateImage.isGenerating = true;
                    }
                }
            });

            slideCategories.push({
                slideCategory: category.name,
                slideReasoning: idea.slideReasoning,
                slideConfidence: idea.slideConfidence,
                models
            });
        }

        slideCategories.forEach(category => {
            category.models.forEach((model, idx) => {
                let elementsWithImages = findElementsWithImages(model);
                if (elementsWithImages.some(element => element.__generateImage.isGenerating && !element.__generateImage.isSlideImage)) {
                    AiGenerationService.generateImagesForSlide({ slide: model })
                        .then(({ slide }) => {
                            category.models[idx] = slide;
                            this._updateState({ slideCategories });
                        });
                }
            });
        });

        this._updateState({ slideCategories });
    }

    async regenerateSlideImage(imagePrompt, imageStyle) {
        let { currentSlide, slideImage, canvasController, slideCategories: currentSlideCategories } = this._state;

        if (!imagePrompt) {
            return;
        }

        imageStyle = imageStyle || slideImage?.imageStyle || "";

        await currentSlide.resetSlideImage();

        let slideCategories = _.cloneDeep(currentSlideCategories);
        slideCategories.forEach(category => {
            category.models = category.models.map(model => resetSlideImage(model));
        });

        await this._updateState({
            slideImage: {
                ...slideImage,
                assetId: null,
                isGenerating: true
            },
            slideCategories
        });

        let { slide } = await AiGenerationService.regenerateSlideImage({
            slide: currentSlide.attributes,
            imagePrompt,
            imageStyle
        });

        currentSlide.update(slide);
        await currentSlide.updatePromise;

        let newSlideImage = currentSlide.getMetadata().generatedModel?.slideImage;

        slideCategories = _.cloneDeep(slideCategories);
        slideCategories.forEach(category => {
            category.models = category.models.map(model => applySlideImage(model, newSlideImage));
        });

        await this._updateState({
            slideImage: newSlideImage,
            slideCategories
        });
    }

    // updateSlideImage(slideImage) {
    //     let { slideCategories: currentSlideCategories } = this._state;
    //
    //     slideCategories = _.cloneDeep(slideCategories);
    //     slideCategories.forEach(category => {
    //         category.models = category.models.map(model => applySlideImage(model, newSlideImage));
    //     });
    //
    //     this._updateState({ slideImage });
    // }

    /*
    renderSlideModels = async (generatedSlides, slidePrompt) => {
        const { currentSlide } = this.props;

        let slideCategories = [];
        for (let slide of generatedSlides) {
            let slideModel = slide.slideData;
            slideModel.slideImage = currentSlide.getMetadata().generatedModel?.slideImage;
            slideModel.imageStylePrompt = currentSlide.getMetadata().imageStylePrompt;

            console.log("Category", slideModel.slideCategory);
            console.log("Reasoning:", slideModel.slideReasoning);
            console.log(slideModel);

            let category = CategoryController.getCategory(slideModel.slideCategory);
            let models = category.getSlideModels(slideModel);

            // copy over metadata from the generated slide data
            models = models.map(model => ({
                ...model,
                metadata: {
                    ...currentSlide.getMetadata(),
                    ...model.metadata,
                    generatedSlides,
                    aiGenerated: true,
                    slidePrompt: slidePrompt,
                    slideCategory: slideModel.slideCategory,
                    slideReasoning: slideModel.slideReasoning,
                    slideConfidence: slideModel.slideConfidence
                }
            }));

            models.forEach(model => {
                let elementsWithImages = findElementsWithImages(model);
                for (let element of elementsWithImages) {
                    if (!element.content_value && element.__generateImage) {
                        element.__generateImage.isGenerating = true;
                    }
                }
            });

            slideCategories.push({
                slideCategory: slideModel.slideCategory,
                slideReasoning: slideModel.slideReasoning,
                slideConfidence: slideModel.slideConfidence,
                models
            });
        }

        await this.setStateAsync({
            slideCategories,
            isGenerating: false
        });

        for (let cat of slideCategories) {
            let models = cat.models;
            for (let idx = 0; idx < models.length; idx++) {
                let { slide } = await AiGenerationService.generateImagesForSlide({
                    slide: models[idx]
                });

                if (this.state.slideCategories !== slideCategories || this.hasBeenUnmounted) {
                    // If the preview models have changed or the component has been unmounted, stop generation
                    break;
                }

                let { update, hasUpdates } = computeChangeSet(models[idx], slide);
                if (hasUpdates) {
                    let updatedModel = mergeChanges(models[idx], update);
                    this.setState(state => {
                        // Keep the array reference, only replace a single model
                        const slideCategories = state.slideCategories;
                        slideCategories[slideCategories.indexOf(cat)].models[idx] = updatedModel;
                        return {
                            ...state,
                            slideCategories
                        };
                    });
                }
            }
        }
    }
     */
}

const slideAiController = new SlideAiController(initialState);
export default slideAiController;

